require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-broadsheet-feature-article.json") })
        }
      }, "path---news-broadsheet-feature-article");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-broadsheet-feature-article!./.cache/json/news-broadsheet-feature-article.json
// module id = 799
// module chunks = 231608221292675